(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(inventoryActionsStatusConfig);


	function inventoryActionsStatusConfig (dashboardProvider) {
		// register widget
		dashboardProvider.widget(
			'inventoryActionsStatus', {
				name: 'Inventory Action Summary',
				description: 'The number or value of Inventory Actions by status, grouped by week created.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/inventory-actions-status.jpg',
				categories: ['All', 'Inventory'],
				config: {},
				slideshowView: true,
				isActive: true,
				controller: 'inventoryActionsStatusCtrl',
				templateUrl: '/application/f/dashboard/widgets/inventory-actions-status.html',
				drillDownUrl: '',
				reload: true,
				isDrillDown: true
			}
		);
	}
})();
